import { useMutation } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';

export const useCreateAmazonPaySession = () => {
  const mutation = useMutation({
    mutationFn: paymentRepo.getAmazonPayCheckoutSession,
  });

  return useMutationMemoized(mutation);
};

export type CreateAmazonPaySessionMutation = ReturnType<typeof useCreateAmazonPaySession>;
